export const ARTICLE_MODAL_BUTTON_TEST_ID = 'ArticleModalButton';
export const ARTICLE_MODAL_NOTIFICATION_TOGGLE_TEST_ID = 'ArticleModalNotificationToggle';
export const ARTICLE_MODAL_NICKNAME_TEST_ID = 'ArticleModalNickname';
